module.exports = __webpack_public_path__ + "static/progetto_valtellinapalace2-d2378ed53ca6aeee7eb72ac397a5d921.jpg";